import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { SetTenant } from "../../../../../../redux/feature/TenantSlice";
import { useState, useEffect } from "react";
import { getListTenant } from "../requests/request";

export default function SelectTenant() {
    const tenantId = useAppSelector(state => state.TenantSlice.id);
    const dispatch = useAppDispatch();
    const [tenants, setTenants] = useState([
        { id: '', Name: '', Domain: '' }
    ]);

    useEffect(() => {
        getListTenant().then(response => {
            setTenants(response.data);
            if (response.data.length > 0) {
                dispatch(SetTenant(Number(response.data[0].id)));
            }
        });
    }, [dispatch]);

    return (
        <div className="align-items-center px-lg-6">
            <label className='fw-bolder f-parrafo  mb-0'>Tenant</label>
            <select
                style={{ height: '37.15px', paddingTop: '0', paddingBottom: '0' }}
                required
                className="form-select form-select-solid f-parrafo text-marino border-gray-300 w-200px"
                aria-label="Select example"
                onChange={e => dispatch(SetTenant(Number(e.target.value)))}
                value={tenantId}
            >
                {
                    tenants.map((tenant: any, i: any) =>
                        <option key={i} value={tenant.id}>{tenant.Name}</option>
                    )
                }
            </select>
        </div>
    );
}